/* ============================================================
   ROBA LUCA — het grote woordmerk op de hero

   Dit bestand doet nog maar één ding: een transform op de kopie
   zetten die bij de scrollstand hoort. Alles daaromheen zit nu in
   Liquid en CSS.

   Waarom dat zo hoort. De vorige versie maakte de kopie zelf aan
   en mat elke frame waar het echte woordmerk stond. Daardoor stond
   er bij de eerste verfbeurt nog de gewone navigatie -- de flits
   die Lucas zag. Nu staat de kopie in de HTML
   (snippets/header-logo.liquid) en staat zijn beginstand in CSS
   (assets/rl-hero.css), dus het eerste beeld klopt al vóór dit
   script draait.

   Elke frame meten hoeft ook niet meer. De kopie hangt in
   .header__heading, net als het echte woordmerk, en die is
   position: relative. Ze hebben dus dezelfde offsetParent en
   schuiven samen mee als de sticky header omhoog kruipt. Het
   verschil tussen hun posities is daarmee een vast getal, één keer
   te meten -- en met offsetLeft/offsetTop/offsetWidth, die geen
   last hebben van de transform die we er zelf op zetten.

   Op scroll 0 is de transform translate(0,0) scale(1): precies
   niets. De eerste frame van dit script verandert dus niets aan
   wat er al stond.

   Of het effect aan is, beslist CSS. Staat de kopie op display:
   none -- geen hero, al gescrold, smal scherm, of beweging beperkt
   -- dan is offsetWidth 0 en doen we niets.

   Ingeladen vanuit snippets/rl-hero.liquid, alleen als de
   instelling "Groot woordmerk aanzetten" aanstaat.
   ============================================================ */
(function () {
  'use strict';

  /* Waar Zenith zijn header wit maakt: de klasse
     shopify-section-header-sticky verschijnt op 70 px, nagemeten.
     Op dezelfde afstand is de kopie uitgekrompen, zodat het
     overnemen door het echte woordmerk niet te zien is. */
  var AFSTAND = 70;

  var sectie = document.querySelector('.shopify-section-header');
  if (!sectie) return;
  var header = sectie.querySelector('.header');
  if (!header) return;

  /* Het woordmerk in de header. Niet querySelector op de sectie:
     in de menulade zit er ook een, en die staat eerder in de DOM. */
  var titel = null;
  for (var i = 0; i < header.children.length; i++) {
    if (header.children[i].classList.contains('header__heading')) { titel = header.children[i]; break; }
  }
  if (!titel) titel = header.querySelector('.header__left > .header__heading');
  if (!titel) return;

  var doel = titel.querySelector('.header__heading-link');
  var kopie = titel.querySelector('.rl-hero-logo');
  if (!doel || !kopie) return;

  /* Waar de bovenkant van de letters moet komen: op die van het
     eerste menu-item. Is er geen inline menu, dan de knoppen
     rechts; is er niets, dan blijft de waarde uit de CSS staan.

     🔴 Hier zat de fout die Lucas op 21/09 op tablet zag.
     querySelector trekt zich niets aan van display: none, en
     Zenith klapt zijn inline menu in de hamburger zodra het niet
     meer past — gemeten: weg op 1152 px, terug op 1199, en dat
     punt schuift mee met het aantal menu-items. In die band vond
     de oude regel nog steeds de link "Shop", maar die had een rect
     van nul. lettersTop() kwam daardoor op 4,8 uit in plaats van
     ergens in de header, en het grote woordmerk landde 42 px te
     hoog: half achter de announcement bar. Boven 1199 px en onder
     990 px was er niets te zien, want daar is het menu er wél of
     staat de kopie uit.

     Een element zonder client rects wordt niet getekend —
     display: none op zichzelf of op een voorouder. visibility
     staat er los bij, want dat houdt de doos wél. */
  var zichtbaar = function (el) {
    if (!el || !el.getClientRects().length) return false;
    return getComputedStyle(el).visibility !== 'hidden';
  };

  /* Bij elke meting opnieuw kiezen en niet één keer bij het laden:
     sleept iemand zijn venster over die band heen, dan verandert
     het antwoord. */
  var kiesAnker = function () {
    var lijst = header.querySelectorAll(
      '.header__inline-menu a, .header__inline-menu summary, .header__buttons a, .header__buttons button'
    );
    for (var i = 0; i < lijst.length; i++) {
      if (zichtbaar(lijst[i])) return lijst[i];
    }
    return null;
  };

  var wortel = document.documentElement;
  /* getoond begint bij wat er al staat: sinds 28/09 kan het stukje in
     snippets/rl-hero.liquid de klasse al vóór de eerste verfbeurt
     gezet hebben. Begon dit op false, dan zou een verkeerde gok daar
     nooit rechtgezet worden (de klasse zou blijven staan). */
  var dx = 0, dy = 0, schaal = 1, bezig = false, gemeten = false,
      getoond = wortel.classList.contains('rl-hero-toon');

  /* Het diepste element dat de tekst draagt: daar staan de
     lettergrootte en de regelhoogte die we nodig hebben. */
  var tekstElement = function (el) {
    var huidig = el;
    for (var d = 0; d < 6; d++) {
      var volgende = null;
      for (var n = 0; n < huidig.children.length; n++) {
        var kind = huidig.children[n];
        if (kind.textContent && kind.textContent.trim() && zichtbaar(kind)) {
          volgende = kind;
          break;
        }
      }
      if (!volgende) break;
      huidig = volgende;
    }
    return huidig;
  };

  /* De bovenkant van de letters van het menu, in schermcoördinaten.

     De regeldoos is hoger dan de letters: er zit halve leading
     boven, en daarbinnen zit boven de hoofdletters nog het verschil
     tussen de ascent van het lettertype en de werkelijke inkt.
     Canvas geeft allebei die maten, dus rekenen we het uit in
     plaats van het te schatten. Lukt dat niet, dan valt het terug
     op de bovenkant van de regel. */
  var lettersTop = function (anker) {
    var el = tekstElement(anker);
    var r = el.getBoundingClientRect();
    var top = r.top;
    try {
      var c = getComputedStyle(el);
      var ctx = document.createElement('canvas').getContext('2d');
      ctx.font = c.fontStyle + ' ' + c.fontWeight + ' ' + c.fontSize + '/' + c.lineHeight + ' ' + c.fontFamily;
      var m = ctx.measureText((el.textContent || '').trim() || 'H');
      if (m.fontBoundingBoxAscent && m.actualBoundingBoxAscent) {
        var lh = parseFloat(c.lineHeight) || r.height;
        var halveLeading = (lh - (m.fontBoundingBoxAscent + m.fontBoundingBoxDescent)) / 2;
        top = r.top + halveLeading + m.fontBoundingBoxAscent - m.actualBoundingBoxAscent;
      }
    } catch (e) {}
    return top;
  };

  /* Hoeveel lege ruimte er binnen de doos van de kopie boven de
     inkt zit. getBBox geeft de echte inktgrenzen van de SVG, dus
     dit blijft kloppen als er ooit een bestand ingeplakt wordt met
     lucht erboven. Bij een PNG weten we het niet en nemen we nul. */
  var inktOffset = function (hoogte) {
    var svg = kopie.querySelector('svg');
    if (svg && svg.getBBox && svg.viewBox && svg.viewBox.baseVal && svg.viewBox.baseVal.height) {
      try {
        return (svg.getBBox().y / svg.viewBox.baseVal.height) * hoogte;
      } catch (e) {}
    }
    return 0;
  };

  var meet = function () {
    gemeten = false;
    /* Staat de kopie uit, dan valt er niets te meten. */
    if (!kopie.offsetWidth) return;

    var anker = kiesAnker();
    var top = null;
    if (anker) {
      var inkt = inktOffset(kopie.offsetHeight);
      top = lettersTop(anker) - titel.getBoundingClientRect().top - inkt;
    }

    /* Negatief kan niet kloppen: het anker zit per definitie ín de
       header, en .header__heading begint bovenaan diezelfde rij.
       Komt er toch een negatieve waarde uit, dan is de meting
       mislukt en is de waarde uit de CSS beter dan een foute.
       removeProperty en niet niets doen, want een eerdere geslaagde
       meting zou anders blijven staan. */
    if (top !== null && top >= 0) {
      kopie.style.top = top.toFixed(2) + 'px';
    } else {
      kopie.style.removeProperty('top');
    }

    /* offsetLeft en offsetTop staan allebei tegenover .header__heading
       en tellen onze transform niet mee. */
    dx = doel.offsetLeft - kopie.offsetLeft;
    dy = doel.offsetTop - kopie.offsetTop;
    schaal = kopie.offsetWidth ? doel.offsetWidth / kopie.offsetWidth : 1;
    gemeten = true;
  };

  var teken = function () {
    bezig = false;
    var y = window.scrollY || window.pageYOffset || 0;
    var p = AFSTAND > 0 ? y / AFSTAND : 1;
    if (p < 0) p = 0;
    if (p > 1) p = 1;

    wortel.style.setProperty('--rl-hero-p', p.toFixed(4));

    /* 🔴 De scrollstand is het enige dat CSS niet zelf kan weten,
       en precies daar ging het mis (21/09, gefilmd door Lucas).

       De regel in rl-hero.css hing aan Zeniths eigen
       .shopify-section-header-sticky. Die klasse zet Zenith pas bij
       het scrollen, en bij een verversing herstelt de browser je
       scrollpositie ná de eerste verfbeurt. Ververs je dus halverwege
       de pagina, dan is de eerste getekende frame er één van bovenaan:
       doorzichtige header met het grote woordmerk, en pas daarna
       klapt hij naar de juiste stand.

       Nu beslist dit script het, en die volgorde klopt wél.
       Nagemeten op de preview, homepage op scroll 300, verversen:

         script draait op        425,9 ms  (readyState interactive)
         scrollY op dat moment     436     -- dus al hersteld
         first paint op          564,0 ms

       138 ms marge. Het script is defer, dus het draait na het
       ontleden van de HTML maar vóór de eerste verfbeurt -- en tegen
       die tijd staat de scroll er al. De eerste frame klopt dus
       meteen, in allebei de richtingen.

       gemeten op false: de doos is net van maat veranderd, dus de
       oude meting deugt niet meer. Hieronder wordt er opnieuw
       gemeten, en dan is offsetWidth ook niet meer nul. */
    var toon = p < 1;
    if (toon !== getoond) {
      getoond = toon;
      wortel.classList.toggle('rl-hero-toon', toon);
      gemeten = false;
    }

    if (!gemeten) {
      /* De kopie kan net aangegaan zijn, bijvoorbeeld na een
         resize over de 990 px heen. */
      if (!kopie.offsetWidth) return;
      meet();
      if (!gemeten) return;
    }

    kopie.style.transform =
      'translate(' + (dx * p).toFixed(2) + 'px, ' + (dy * p).toFixed(2) + 'px)' +
      ' scale(' + (1 + (schaal - 1) * p).toFixed(4) + ')';
  };

  var vraag = function () {
    if (bezig) return;
    bezig = true;
    requestAnimationFrame(teken);
  };

  meet();
  teken();

  /* Waar je stond bij het verlaten van de pagina, voor het stukje in
     snippets/rl-hero.liquid: dat moet bij een verversing weten of je
     bovenaan terugkomt, en de browser vertelt dat pas na de eerste
     verfbeurt. pagehide en niet beforeunload: dat vuurt ook op
     telefoons en laat de terug/vooruit-cache van de browser heel. */
  window.addEventListener('pagehide', function () {
    try {
      sessionStorage.setItem(
        'rl-hero-y:' + location.pathname + location.search,
        String(Math.round(window.scrollY || window.pageYOffset || 0))
      );
    } catch (e) {}
  });

  window.addEventListener('scroll', vraag, { passive: true });
  window.addEventListener('resize', function () { meet(); vraag(); }, { passive: true });

  /* Het woordmerk wordt pas in zijn eigen lettertype gemeten als
     dat geladen is; daarvoor staat er een terugvallettertype met
     andere maten. */
  if (document.fonts && document.fonts.ready) {
    document.fonts.ready.then(function () { meet(); vraag(); });
  }
})();